
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cricket/series",
      function () {
        return require("private-next-pages/cricket/series/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cricket/series"])
      });
    }
  